module.exports = __webpack_public_path__ + "static/media/nonord-c-10.3b9a3496.mp3";